import { asyncComponent } from '@wkda/after-framework';
import routesConfig from './routesConfig';

const ConversationalCarleadPage = asyncComponent({
  loader: () => import('./pages/index'),
});

const routes = routesConfig([ConversationalCarleadPage]);

export default routes;
